<div
  [hidden]="!modalIsVisible"
  class="overlay"
  [class.active]="modalIsVisible"
  (click)="close()"
></div>
<div
  [hidden]="!modalIsVisible"
  class="modal-wrapper"
  [class.active]="modalIsVisible"
  #wrapper
>
  <button class="modal-wrapper__close-icon-box" (click)="close()">
    <em class="material-icons modal-wrapper__close-icon-box__icon">close</em>
  </button>
  <ng-content></ng-content>
</div>
